import { type BaseDto, type Nullable } from "@pasta/box-v2";
import { type Dictionary } from "lodash";
import { type FluxElementDto } from "./flux-element.dto";
import { type LetterFileHistoryDto } from "./history.dto";
import { type LetterFileCCUserDto } from "./letter-file-cc-user.dto";
import { type LetterFileCommentDto } from "./letter-file-comment.dto";
import { type LetterFileFolderDto } from "./letter-file-folder.dto";
import { type LetterFileTagDto } from "./letter-file-tag.dto";
import { type LetterFileUserTagDto } from "./letter-file-user-tag.dto";

export enum LetterFileStatus {
  UPSTREAM = "UPSTREAM",
  DOWNSTREAM = "DOWNSTREAM",
  CURRENT = "CURRENT",
  ARCHIVED = "ARCHIVED",
  UNKNOWN = "UNKNOWN",
  CC = "CC",
}

export interface LetterFileDto extends BaseDto {
  name?: string;
  chronoNumber: string;
  currentPosition: number;
  deadline?: string;
  arrivalDate?: string;
  externalMailNumber?: string;
  draft: boolean;
  archived: boolean;
  unArchivedDate?: string;
  tags?: LetterFileTagDto[];
  upstream?: FluxElementDto[];
  downstream?: FluxElementDto[];
  current: Nullable<FluxElementDto>;
  ccUsers?: LetterFileCCUserDto[];
  comments?: LetterFileCommentDto[];
  folders?: LetterFileFolderDto[];
  status: LetterFileStatus;
  highlight?: Dictionary<string[]>;
  senderOrganization?: string;
  senderName?: string;
  senderRole?: string;
  mailType?: string;
  recipientName?: string;
  manager?: string;
  history?: LetterFileHistoryDto[];
  userTags: LetterFileUserTagDto[];
  isDeletable: boolean;
  isAuthor: boolean;
  signaturePositionsCount: number;
}

export interface UpdateLetterFileDto {
  name?: string;
  deadline?: Date;
  arrivalDate?: Date;
  externalMailNumber?: string;
  tags?: number[];
  flux?: string[];
  folders?: number[];
}

export interface LetterFileSearchDto {
  searchPattern?: string;
  archived?: boolean | null;
  tags?: string[];
  alreadySeen?: boolean;
  createdByMe?: boolean;
  inTodo?: boolean;
  inCurrent?: boolean;
  inDone?: boolean;
  inCC?: boolean;
  startDate?: string;
  endDate?: string;
  createdStartDate?: string;
  createdEndDate?: string;
  fileTypes?: string[];
}

export interface RequestExportDto extends LetterFileSearchDto {
  withDocuments?: boolean;
}

export interface LetterFileCloneDto {
  name: string;
  cloneStream: boolean;
  cloneCC: boolean;
  cloneComments: boolean;
  cloneDocuments: boolean;
  cloneMetadata: boolean;
}

export interface TransferLfDto {
  sourceMail: string;
  recipientMail: string;
  includeUpstream: boolean;
  includeDownstream: boolean;
  includeCC: boolean;
  includeArchived: boolean;
  afterChrono?: string;
  endDate?: string;
}
